import { createContext, use } from "react"
import type { Platform } from "./detect"
import type { StoreId } from "./detect-store"
import { StoreProvider } from "./store-context"

const PlatformContext = createContext<Platform | null>(null)

export function PlatformProvider({
	platform,
	store,
	children,
}: {
	platform: Platform
	store: StoreId | null
	children: React.ReactNode
}) {
	return (
		<PlatformContext value={platform}>
			<StoreProvider store={store}>{children}</StoreProvider>
		</PlatformContext>
	)
}

export function usePlatform(): Platform {
	const platform = use(PlatformContext)
	if (!platform) {
		throw new Error("usePlatform must be used within PlatformProvider")
	}
	return platform
}
